import React from "react";
import { TvDiv, TvSmall, TvAnchor } from "@trustvid/design-system";
import { AUTH_PAGE_COPY } from "./loginPageContent";

const AuthPageFooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <TvDiv className="tv-login-page__footer text-center py-2 px-4">
      <TvSmall className="text-muted">
        {AUTH_PAGE_COPY.footerCopyright(currentYear)}
        {" · "}
        <TvAnchor
          href={AUTH_PAGE_COPY.termsUrl}
          className="text-muted text-decoration-none"
          target="_blank"
          rel="noopener noreferrer"
        >
          {AUTH_PAGE_COPY.termsLabel}
        </TvAnchor>
        {" · "}
        <TvAnchor
          href={AUTH_PAGE_COPY.privacyUrl}
          className="text-muted text-decoration-none"
          target="_blank"
          rel="noopener noreferrer"
        >
          {AUTH_PAGE_COPY.privacyLabel}
        </TvAnchor>
      </TvSmall>
    </TvDiv>
  );
};

export default AuthPageFooter;
